<template>
  <div class="page-profile-edit" style="overflow-x: hidden">
    <div class="extension-details" v-if="user">
      <el-row :gutter="20">
        <el-col :span="5">
          <h4>Profile Type:</h4>
        </el-col>
        <el-col :span="14">
          <span> {{ userTitle() }}</span>
        </el-col>
      </el-row>
      <hr />
      <el-row :gutter="20">
        <el-col :span="5">
          <h4>Email:</h4>
        </el-col>
        <el-col :span="14">
          <span> {{ user.email }}</span>
        </el-col>
      </el-row>
      <hr />
      <el-row :gutter="20">
        <el-col :span="5">
          <h4>Extension:</h4>
        </el-col>
        <el-col :span="14">
          <span> {{ user.myExtension.number }} </span>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="5">
          <el-checkbox @input="onCheckbox" v-model="forwardForm.enableForward">
            Enable forwarding
          </el-checkbox>
        </el-col>
        <el-col :span="14" v-if="forwardingNumber && forwardForm.enableForward">
          <el-tag type="info"
            >Currently Forwarding To: {{ numberFormatter(forwardingNumber) }}
            {{ forwardingEntity ? `(${forwardingEntity})` : "" }}</el-tag
          >
        </el-col>
      </el-row>
      <div v-if="forwardForm.enableForward">
        <h4 class="mb-0">Update Forwarding</h4>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="el-input el-input--prefix">
              <input
                v-model="forwardForm.forwardingNumber"
                type="text"
                autocomplete="off"
                placeholder="Enter number"
                class="el-input__inner"
                v-mask="'(###)-###-####'"
              />
              <span class="el-input__prefix">Number</span>
            </div>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" @click="updateForwarding">Save</el-button>
          </el-col>
        </el-row>
      </div>
      <hr />
      <el-row :gutter="20" v-if="userDirectDials.length">
        <el-col :span="5">
          <h4>Direct Dial Numbers:</h4>
        </el-col>
        <el-col :span="14">
          <el-tag type="info">
            <span v-for="(item, index) in userDirectDials" :key="item">
              {{ numberFormatter(item) }}
              {{ index === userDirectDials.length - 1 ? "" : ", " }}
            </span>
          </el-tag>
        </el-col>
      </el-row>
      <hr v-if="userDirectDials.length" />
      <el-row :gutter="20">
        <el-col :span="5">
          <h4>Download App:</h4>
        </el-col>
        <el-col :span="20">
          <el-row class="flex align-center mt-10">
            <div class="qr-code-container">
              <img :src="iOSQrCodeURL" alt="downloadQrCode" />

              <div class="icon-container">
                <a :href="branding.iosURL" target="_blank"
                  ><img
                    width="100"
                    height="100"
                    class="image-class"
                    src="https://miscdts.s3.amazonaws.com/ios_store.png"
                    alt="iOS"
                /></a>
              </div>
            </div>
            <div class="qr-code-container">
              <img :src="androidQrCodeURL" alt="downloadQrCode" />
              <div class="icon-container">
                <a :href="branding.androidURL" target="_blank"
                  ><img
                    width="100"
                    height="100"
                    class="image-class"
                    src="https://miscdts.s3.amazonaws.com/android_store.png"
                    alt="Android"
                /></a>
              </div>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-checkbox v-model="passwordReset" :label="true" class="mt-30">
      Reset Password
    </el-checkbox>
    <div class="password-reset-form" v-if="passwordReset">
      <el-row :gutter="20">
        <el-col :span="10">
          <el-input
            type="password"
            v-model="password"
            placeholder="Enter New Password"
            clearable
          >
            <template class="label-prefix" slot="prefix">New Password</template>
          </el-input>
          <span
            class="pw-length-error"
            v-if="!passwordValid && password.length"
          >
            Must be at least 5 characters!
          </span>
        </el-col>
        <el-col :span="6">
          <el-button :disabled="!passwordValid" @click="onSubmit"
            >Submit</el-button
          >
        </el-col>
      </el-row>
    </div>

    <mfa-settings />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import MfaSettings from "./mfa/mfa-settings.vue";
import { phoneNumberFormatter } from "@/globals/globals";
import feathersClient from "../../../../feathers/feathers-client";

export default {
  name: "ProfileEdit",

  components: {
    MfaSettings,
  },

  data() {
    return {
      passwordReset: false,
      password: "",
      passwordValid: false,
      meetURL: "",
      meetDial: "",
      loadingMeetInfo: true,
      forwardingNumber: "",
      forwardingEntity: "",
      forwardForm: {
        command: "forwardExtension",
        extId: null,
        enableForward: false,
        tenantId: null,
        forwardingNumber: "",
      },
    };
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    userDirectDials() {
      if (this.user) {
        return this.user.myExtension ? this.user.myExtension.directDials : [];
      }
    },
    branding() {
      return this.$store.state.branding;
    },
    iOSQrCodeURL() {
      return `https://api.qrserver.com/v1/create-qr-code/?size=75x75&data=${this.branding.iosURL}`;
    },
    androidQrCodeURL() {
      return `https://api.qrserver.com/v1/create-qr-code/?size=75x75&data=${this.branding.androidURL}`;
    },
  },

  watch: {
    password() {
      this.passwordValid = this.password.length >= 5;
    },
  },

  methods: {
    ...mapActions("user-settings", {
      createUserSettings: "create",
    }),

    numberFormatter(val) {
      return phoneNumberFormatter(val);
    },

    onSubmit() {
      this.$confirm("Reset Your Password?", {})
        .then(() => {
          const passwordResetService = feathersClient.service("password-reset");
          passwordResetService
            .create({
              password: this.password,
            })
            .then((res) => {
              this.$notify({
                title: "Success",
                message: "Password Reset Successful!",
                type: "success",
              });
              this.password = "";
              this.passwordReset = false;

              // ⭐️ `Manual Password Reset` user event log ⭐️ //
              this.$store.dispatch("userEvents/create", {
                event: "Password Reset",
                type: "Manual",
              });
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => true);
    },

    resizeLabelPosition() {
      if (window.innerWidth <= 768) {
        this.labelPosition = "top";
      }
    },

    userTitle() {
      const { userRole } = this.user;
      switch (userRole) {
        case 1:
          return "Platform Admin";
        case 3:
          return "Tenant Admin";
        case 5:
          return "Basic User";
        case 7:
          return "Queue Manager";
        case 9:
          return "Reports Admin";
        case 11:
          return "Partner Admin";
        case 12:
          return "Pharmacy Owner";
        case 13:
          return "Pharmacy Admin";
        case 14:
          return "Pharmacy User";
      }
    },

    onCheckbox(checked) {
      if (!checked) {
        // ⭐️ `DISABLE EXTENSION FORWARDING` user event log ⭐️ //
        this.$store.dispatch("userEvents/create", {
          event: "Disable Extension Forwarding",
        });
        this.createUserSettings({
          command: "forwardExtension",
          extId: this.forwardForm.extId,
          enableForward: false,
        }).then((res) => {
          this.forwardingNumber = "";
          this.forwardingEntity = "";
          this.$notify.success({
            title: "Forwarding Disabled",
            message: "Extension forwarding successfully disabled",
          });
        });
      }
    },

    updateForwarding() {
      const { forwardingNumber } = this.forwardForm;
      const body = { ...this.forwardForm };

      // ⭐️ Check for valid forwarding number ⭐️ //
      if (!forwardingNumber || forwardingNumber.includes("_")) {
        this.$notify.error({
          title: "Invalid forwarding number.",
          message: "The forwarding number must contain 10 digits.",
        });
        return;
      }

      body.forwardingNumber = forwardingNumber.replace(/\(|\)|-/g, "");

      this.createUserSettings(body)
        .then(() => {
          this.forwardingNumber = body.forwardingNumber;
          this.forwardingEntity = "";
          this.forwardForm.forwardingNumber = "";
          this.$notify.success({
            title: "Forwarding enabled",
            message: "Extension forwarding successfully enabled.",
          });

          // ⭐️ `ENABLE EXTENSION FORWARDING` user event log ⭐️ //
          this.$store.dispatch("userEvents/create", {
            event: "Enable Extension Forwarding",
            number: forwardingNumber,
          });
        })
        .catch((error) => {
          if (error.hasOwnProperty("errors")) {
            this.$notify({
              title: error.message,
              message: error.errors[Object.keys(error.errors)[0]],
              type: "error",
            });
          } else {
            this.$notify({
              title: error.name,
              message: error.message,
              type: "error",
            });
          }
        });
    },
  },

  async created() {
    if (this.user && this.user.myExtension) {
      const { id, tenantId, unconditionalStatus } = this.user.myExtension;

      this.forwardForm.extId = id;
      this.forwardForm.tenantId = tenantId;

      // ⭐️ Check if forwarding is enabled ⭐️ //
      const extension = await feathersClient.service("extensions").get(id);

      if (!extension.unconditionalStatus) {
        return;
      }

      // ⭐️ Grab forwarding destination if any ⭐️ //
      const { forwardingDestination } = extension;
      if (!forwardingDestination) {
        return;
      }

      this.forwardingNumber = forwardingDestination.name;
      this.forwardingEntity = forwardingDestination.entity;
      this.forwardForm.enableForward = true;
    }
  },

  mounted() {
    this.resizeLabelPosition();
    window.addEventListener("resize", this.resizeLabelPosition);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resizeLabelPosition);
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";

.el-checkbox {
  width: 200px;
}

.el-col {
  position: relative;
}

.el-row {
  display: flex;
  align-items: center;
}

.pw-length-error {
  position: absolute;
  bottom: -8px;
  font-size: 8pt;
  left: 13px;
  color: $voxo-orange;
}

.password-reset-form {
  padding: 20px 0;
}

.el-checkbox {
  margin-left: 0;
}

.qr-code-container {
  padding: 0 20px 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-class {
  margin-top: -20px;
}

@media (max-width: 860px) {
  .el-row {
    flex-wrap: wrap;

    .el-col {
      width: 100%;
      max-width: 300px;
    }
  }
}
</style>
